export default "__VITE_ASSET__ZN8ENxE8__"